import { isNil } from 'lodash-es';

export const customFixed = (value: number | undefined, fixed: number = 2) => {
  return isNil(value) ? undefined : Number(value.toFixed(fixed));
};
